import { Button, Stack } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useCallback, useState } from 'react';
import { useNotify, useTranslate } from 'react-admin';
import { CustomBreadcrumbs } from '../../../../../components/custom-breadcrumbs';
import { DashboardContent } from '../../../../../layouts/dashboard';
import { paths } from '../../../../../routes/paths';
import { PermissionGuard } from '../../../../../routes/components/permission-guard';
import ErrorPage403 from '../../../../error/403';
import { bbResetToDefault } from '../../../services/blindBoxService';
import { SectionOverview } from './SectionOverview';

export default function BlindBoxOverviewList() {
  const t = useTranslate();
  const notify = useNotify();
  const [refreshKey, setRefreshKey] = useState(0);
  const [resetting, setResetting] = useState(false);

  const refreshAll = useCallback(() => setRefreshKey((k) => k + 1), []);

  const resetDefault = async () => {
    if (!window.confirm(t('module.blindBox.confirmReset'))) return;
    setResetting(true);
    try {
      await bbResetToDefault();//设置成默认数据
      notify(t('module.blindBox.saveOk'), { type: 'success' });
      refreshAll(); //重新请求dashboard Get
    } catch (e: any) {
      notify(e?.message || 'Error', { type: 'error' });
    } finally {
      setResetting(false);
    }
  };

  return (
    <PermissionGuard resource="bb-overview" action="read" fallback={<ErrorPage403 />}>
      <DashboardContent maxWidth={false}>
        <CustomBreadcrumbs
          heading={t('module.blindBox.overviewData')}
          links={[
            { name: t('module.blindBox.title'), href: paths.blindBox.overview.root },
            { name: t('module.blindBox.overviewData') },
          ]}
          action={
            <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
              {/*<Button*/}
              {/*  size="small"*/}
              {/*  variant="outlined"*/}
              {/*  color="warning"*/}
              {/*  disabled={resetting}*/}
              {/*  onClick={resetDefault}*/}
              {/*>*/}
              {/*  {t('module.blindBox.resetDefault')}*/}
              {/*</Button>*/}
              <Button size="small" variant="outlined" onClick={refreshAll}>
                {t('module.blindBox.refreshAll')}
              </Button>
            </Stack>
          }
        />
        <SectionOverview refreshKey={refreshKey} />
      </DashboardContent>
    </PermissionGuard>
  );
}
